// extracted by mini-css-extract-plugin
export default {"demoCont":"phtfAKW9SwkNn3dWAWAK","demoVideo":"msyFM4y__9A5bHOLN5U5","demoCloseBtn":"EvapAmz7j0dIqFD25BG1"};